import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import moment from 'moment'
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'

// Actions
import { updateSparePartsReception, getReceptionSparePartDetails } from '../../../../actions/spareparts'
import { closeSlidePanel } from '../../../../actions/common'

// Elements
import LabelWrapper from '../../../elements/labelWrapper'
import CountSpecifier from '../../../elements/countSpecifier'
import Radio from '../../../elements/radio'
// import Check from '../../../elements/check'
import Textarea from '../../../elements/textarea'
import Divider from '../../../elements/divider'
import SlidePanel from '../../../elements/slidePanel'
import Icon from '../../../elements/icon'
import Label from '../../../elements/label'
import Grid from '../../../elements/grid'
import { SparePartModuleIcons } from '../../../elements/icons'
import BottomBar from '../../../elements/bottomBar'
import DateTime from '../../../elements/datetime'
import Time from '../../../elements/time'
import Check from '../../../elements/check'

class ReceptionSlidePanel extends Component {
  constructor (props) {
    super(props)

    this.state = {
      view: 'status',
      totalCount: 0,
      disabled: true,
      Quantity: 1,
      Status: 1,
      Comment: '',
      NewDeliveryDate: false,
      DeliveryDate: '',
      DefaultDate: '',
      DeliveryChange: {
        deliveryDate: '',
        deliveryTime: ''
      },

      ModifySpecific: false,
      modifySpecificSparePart: null,

      sparePartDetails: []
    }

    // this.getSpareParts = this.getSpareParts.bind(this)
    this.onChange = this.onChange.bind(this)
    this.submitSpareParts = this.submitSpareParts.bind(this)
    this.resetState = this.resetState.bind(this)
    this.onDone = this.onDone.bind(this)
    this.changeToModifyStatusView = this.changeToModifyStatusView.bind(this)
    this.onTimeChange = this.onTimeChange.bind(this)
  }

  componentDidMount () {
    this.setState({
      view: this.props.view
    })
  }

  // componentDidUpdate () {
  //   const totalCount = this.props.spareParts.reduce((total, part) => {
  //     return total + (part.Count - part.Handled)
  //   }, 0)

  //   if (totalCount !== this.state.totalCount) {
  //     this.setState({
  //       totalCount: totalCount,
  //       Quantity: totalCount
  //     })
  //   }
  // }

  componentWillReceiveProps (nextProps) {
    const isDiffSpareParts = !isEqual(nextProps.spareParts, this.props.spareParts)

    if (nextProps.view !== this.state.view) {
      this.setState({
        view: nextProps.view
      })
    }

    const isDiff = isDiffSpareParts && nextProps.spareParts.length === 1

    if (isDiff) {
      this.props.getReceptionSparePartDetails(nextProps.spareParts[0]).then(res => {
        const unhandledSparePart = res.data.find(sp => sp.Status === 8)
        const totalCount = unhandledSparePart ? unhandledSparePart.Count : 0

        let date = window.CustomDate(res.data[0].DefaultDate)
        let time = renderFullDate(date, true, true).toString()

        let newState = {
          totalCount: totalCount,
          Quantity: totalCount,
          sparePartDetails: res.data,
          DeliveryChange: {
            deliveryDate: date,
            deliveryTime: time
          }
        }

        if (this.state.view !== 'listDetail' && res.data.length === 1 && !unhandledSparePart) {
          newState = {
            ...newState,
            ...this.changeToModifyStatusView(res.data[0], true)
          }
        } else if (totalCount === 0) {
          newState.view = 'listDetail'
          this.setState({
            DefaultDate: res.data[0].DefaultDate,
            DeliveryChange: {
              deliveryDate: date,
              deliveryTime: time,
              disabled: res.data[0].Status === 1
            }
          })
        }

        this.setState(newState)
      })
    } else if (nextProps.spareParts.length > 1) {
      this.resetState()
    }
  }

  // componentDidMount () {
  //   this.getSpareParts()
  // }

  // componentDidUpdate () {
  //   const isSame = this.props.sparePartNumbers.every(spn => {
  //     return this.state.spareParts.some(sp => {
  //       return spn === (sp.SparePartNumberAlias || sp.OriginalSparePartNumber)
  //     })
  //   })

  //   if (!isEqual(this.state.spareParts, this.props.spareParts)) {
  //     this.getSpareParts()
  //   }
  // }

  // getSpareParts () {
  //   const { spareParts } = this.props

  //   const relevantParts = spareParts.filter(sp => {
  //     return this.props.sparePartNumbers.includes(sp.SparePartNumberAlias || sp.OriginalSparePartNumber)
  //   })

  //   this.setState({
  //     spareParts: relevantParts
  //   })
  // }

  isMultipleSpareParts () {
    const { spareParts } = this.props
    return spareParts.length > 1
  }

  onChange (e) {
    const { name, value, checked } = e.target

    let newValue = value
    if (name === 'Status') {
      newValue = +value
    }
    if (name === 'NewDeliveryDate') {
      newValue = checked
    }

    this.setState({
      [name]: newValue,
      disabled: false
    })
  }

  submitSpareParts () {
    const { Quantity, Status, Comment, ModifySpecific, modifySpecificSparePart, NewDeliveryDate, DefaultDate, DeliveryChange } = this.state
    const isMulti = this.isMultipleSpareParts()
    let momentDate = moment(DeliveryChange.deliveryDate)
    let newDate = momentDate.format('YYYY-MM-DD') + ' ' + DeliveryChange.deliveryTime

    const sparePartsBody = {
      OrderId: this.props.orderId,
      SpareParts: !ModifySpecific ? this.props.spareParts : [ modifySpecificSparePart ],
      Quantity: !isMulti ? Quantity : null,
      Status,
      Comment,
      ModifySpecific: !isMulti ? ModifySpecific : false,
      Filter: this.props.sparePartsFilter,
      DeliveryDate: NewDeliveryDate ? newDate : null
    }

    this.props.updateSparePartsReception(sparePartsBody).then((res) => {
      this.onDone()
    }, (err) => {
      let errorKey = err.response.data.DictionaryKey
      if (errorKey && errorKey === 18109) {
        window.toastr.error(translation(errorKey), translation('216'))
        let date = window.CustomDate(DefaultDate)
        let time = renderFullDate(date, true, true).toString()
        this.setState({
          DeliveryChange: {
            deliveryDate: date,
            deliveryTime: time
          },
          NewDeliveryDate: false
        })
      } else {
        window.toastr.error(translation('960'), translation('216'))
      }
    })
  }

  resetState () {
    this.setState({
      view: 'status',
      totalCount: 0,

      Quantity: 1,
      Status: 1,
      Comment: '',
      ModifySpecific: false,
      modifySpecificSparePart: null,
      NewDeliveryDate: false,
      disabled: true
    })
  }

  onDone () {
    this.resetState()

    this.props.closeSlidePanel('sparePartsReception')

    if (this.props.onDone !== null) {
      this.props.onDone()
    }
  }

  onTimeChange (e) {
    const { value } = e.target

    this.setState({
      DeliveryChange: {
        ...this.state.DeliveryChange,
        deliveryTime: value
      },
      disabled: false,
      NewDeliveryDate: true
    })
  }

  renderDefaultDeliveryTime () {
    const { NewDeliveryDate, DeliveryChange } = this.state
    const inputProps = {
      name: 'date'
    }

    let date = window.CustomDate(DeliveryChange.deliveryDate)
    let time = DeliveryChange.deliveryTime

    const onDateChange = (date) => {
      let momentDate = moment(date)
      this.setState({
        DeliveryChange: {
          ...this.state.DeliveryChange,
          deliveryDate: momentDate.format('YYYY-MM-DD')
        },
        disabled: false,
        NewDeliveryDate: true
      })
    }

    return (
      <LabelWrapper labelText={translation('18107')}>
        <Grid cols={[0.3, 2, 1]}>
          <Check spacing={0} name='NewDeliveryDate' value={NewDeliveryDate} onChange={this.onChange} checked={NewDeliveryDate} />
          <DateTime
            inputProps={inputProps}
            timeFormat={false}
            closeOnSelect
            value={date}
            onChange={onDateChange}
          />
          <Time name='DefaultDate' value={time} onChange={this.onTimeChange} id={10} />
        </Grid>
      </LabelWrapper>
    )
  }

  renderStatusChange () {
    const { spareParts } = this.props
    const { totalCount, Quantity, Status, Comment, disabled } = this.state

    const renderContent = () => {
      const renderPreviousComment = (item, index) => {
        return (
          <div key={index}>
            <Label>{item.Note}</Label>
            <h4>{`${item.NoteUserName} - ${renderFullDate(item.NoteDate)}`}</h4>
            <Divider />
          </div>
        )
      }

      const showCounter = totalCount > 1 && !this.isMultipleSpareParts()
      return (
        <div className='content' key={1}>
          {showCounter && [
            <LabelWrapper labelText={translation(16447)} key={1}>
              <CountSpecifier name='Quantity' value={Quantity} total={totalCount} onChange={this.onChange} />
            </LabelWrapper>,
            <Divider key={2} />
          ]}

          <LabelWrapper labelText={translation(16448)}>
            {this.state.ModifySpecific && <Radio name='Status' value={8} checked={Status === 8} onChange={this.onChange} labelText={translation(16535)} />}
            <Radio name='Status' value={16} checked={Status === 16} onChange={this.onChange} labelText={translation(16452)} />
            <Radio name='Status' value={32} checked={Status === 32} onChange={this.onChange} labelText={translation(16453)} />
            <Radio name='Status' value={64} checked={Status === 64} onChange={this.onChange} labelText={translation(16454)} />
            <Radio name='Status' value={128} checked={Status === 128} onChange={this.onChange} labelText={translation(18108)} />
          </LabelWrapper>

          <Divider />

          {this.renderDefaultDeliveryTime()}

          <Divider />

          <Textarea name='Comment' value={Comment} onChange={this.onChange} labelText={translation(149)} />
          {this.props.previousComments.length > 0 && (
            <div className='previous-comments'>
              <LabelWrapper labelText={translation(16459)}>
                {this.props.previousComments.map(renderPreviousComment)}
              </LabelWrapper>
            </div>
          )}
        </div>
      )
    }

    return [
      <div className='top' key={0}>
        <h1>{translation(13052)}</h1>
        {spareParts.length === 1 && <h3>{`${totalCount} x ${spareParts[0].SparePartNumberAlias || spareParts[0].OriginalSparePartNumber}`}</h3>}
        {spareParts.length > 1 && <h3>{translation(16451)} #</h3>}
      </div>,

      renderContent(),

      <BottomBar
        actionLabelText={translation(16455)}
        onActionClick={this.submitSpareParts}
        cancelLabelText={translation(16444)}
        onCancelClick={this.onDone}
        disabled={disabled}
        key={2}
      />
    ]
  }

  changeToModifyStatusView (part, returnState = false) {
    const newState = {
      view: 'status',
      totalCount: part.Count,
      Quantity: part.Count,
      Status: part.Status,
      ModifySpecific: true,
      modifySpecificSparePart: part,
      DefaultDate: part.DefaultDate,
      disabled: part.Status === 1
    }

    if (returnState) {
      return newState
    }

    this.setState(newState)
  }

  renderListDetail () {
    const { spareParts } = this.props
    const { sparePartDetails, totalCount } = this.state

    const renderContent = () => {
      const renderPart = (part, key) => {
        let icon = SparePartModuleIcons.OK
        if (part.Status !== 16) icon = SparePartModuleIcons.Warning

        let status
        switch (part.Status) {
          case 8:
            status = translation(16457) + '...'
            break
          case 16:
            status = translation(16452)
            break
          case 32:
            status = translation(16453)
            break
          case 64:
          case 128:
            status = translation(18108)
            break
          default:
            status = translation(16454)
            break
        }

        return ([
          <LabelWrapper labelText={`${translation(13052)} - ${status}`} key={key}>
            <Grid cols='min-content 1fr min-content' onClick={() => this.changeToModifyStatusView(part)} align='center'>
              <Icon icon={icon} injectSvg />
              <Grid cols='auto'>
                <Label>{`${part.Count} x ${part.Status === 8 ? part.Suppliers[0].Name : status}`}</Label>
                {part.RequiresPaint && <h4>{translation(16450)}</h4>}
                {part.Pickup && <h4>{translation(16458)}</h4>}
              </Grid>
              <i className='fa fa-chevron-right' />
            </Grid>
          </LabelWrapper>,
          <Divider size={3} />
        ])
      }

      return (
        <div className='content status-list' key={1}>
          {sparePartDetails.map(renderPart)}
        </div>
      )
    }

    const sparePart = spareParts[0] || {}
    return [
      <div className='top' key={0}>
        <h1>{translation(13052)}</h1>
        <h3>{`${totalCount} x ${sparePart.SparePartNumberAlias || sparePart.OriginalSparePartNumber}`}</h3>
      </div>,

      renderContent(),

      <BottomBar
        cancelLabelText={translation(235)}
        onCancelClick={this.onDone}
        key={2}
      />
    ]
  }

  render () {
    let content = null
    switch (this.state.view) {
      case 'status':
      default:
        content = this.renderStatusChange()
        break
      case 'listDetail':
        content = this.renderListDetail()
        break
    }

    return (
      <SlidePanel slidePanelId='sparePartsReception'>
        {content}
      </SlidePanel>
    )
  }
}

ReceptionSlidePanel.defaultProps = {
  onDone: null
}

function mapStateToProps (state) {
  return {
    previousComments: state.spareParts.sparePartsCommentsReception,
    sparePartsFilter: state.spareParts.sparePartsFilterReception
  }
}

export default connect(mapStateToProps, {
  updateSparePartsReception,
  closeSlidePanel,
  getReceptionSparePartDetails
})(ReceptionSlidePanel)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/spareParts/ReceptionSlidePanel/index.js